export const NUMBER_SUFFIX = ['st', 'nd', 'rd', 'th'];

export function formatOrdinalNumber(num: number) {
  const idx = Math.floor(num / 10) !== 1 ? num % 10 : 5;
  return num + (NUMBER_SUFFIX[idx - 1] || 'th');
}
